import { useEffect, useState } from "react";
import { api } from "./api";
import { DEFAULT_CONTENT } from "../data/content";

export function useContent() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    let alive = true;
    api
      .get("/content")
      .then((res) => {
        if (alive && res.data && res.data.bank) {
          setContent({
            ...DEFAULT_CONTENT,
            ...res.data,
            bank: { ...DEFAULT_CONTENT.bank, ...(res.data.bank || {}) },
            social: { ...DEFAULT_CONTENT.social, ...(res.data.social || {}) },
          });
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return content;
}
